import { toSetRows, zoneMix } from './workoutSets';
import styles from '../dashboardCards.module.css';

const SHADES = ['var(--blue-200)', 'var(--blue-300)', 'var(--blue-500)', 'var(--blue-700)', 'var(--blue-800)', 'var(--blue-900)', '#050f2e'];

const NextWorkoutSets = ({ items }) => {
    const rows = toSetRows(items);
    const mix = zoneMix(items);
    if (rows.length === 0) return <p className={styles.muted}>No set details for this workout.</p>;
    const total = mix.reduce((a, z) => a + z.distance, 0);
    const label = `Zone mix: ${mix.map(z => `${z.label} ${z.percent}%`).join(', ')}`;
    return (
        <>
            <div className={styles.subhead}>
                <span>Sets</span>
                <span>Zone</span>
            </div>
            <table className={styles.sets}>
                <tbody>
                    {rows.map((row, i) => (
                        <tr key={i}>
                            <td className={styles.part}>{row.part}</td>
                            <td>
                                {row.description}
                                {row.comment && <small>{row.comment}</small>}
                            </td>
                            <td className={styles.num}>{row.distance.toLocaleString('en-US')}</td>
                            <td>{row.zone && <span className={styles.zoneTag}>{row.zone}</span>}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={styles.subhead} style={{ marginTop: 14 }}>
                <span>Zone mix</span>
                <span>{total.toLocaleString('en-US')} m</span>
            </div>
            <div className={styles.segbar} role="img" aria-label={label}>
                {mix.map((z, i) => (
                    <span key={z.zone} style={{ flex: z.distance, background: SHADES[['rec', 'end1', 'end2', 'end3', 'sp1', 'sp2', 'sp3'].indexOf(z.zone)] }} />
                ))}
            </div>
            <div className={styles.legend}>
                {mix.map(z => (
                    <span key={z.zone}>
                        <i style={{ background: SHADES[['rec', 'end1', 'end2', 'end3', 'sp1', 'sp2', 'sp3'].indexOf(z.zone)] }} />
                        {z.label} {z.percent}%
                    </span>
                ))}
            </div>
        </>
    );
};

export default NextWorkoutSets;
